// utils
import { buildTestId } from '@/utils/helpers.utils';
import _isFunction from 'lodash/isFunction';

// style
import Styled from './RuleItem.styled';
import { COLOR_VARIANTS, Icons, TYPOGRAPHY_VARIANT, Typography, color } from '@tajawal/ct-web-design-system';
import { GenericCallback } from '@/types/common.types';

export type RuleItemProps = {
  message: React.ReactNode;
  icon: React.ReactNode;
  testIdPrefix: string;
  isTextDimmed?: boolean;
  onInfoClick?: GenericCallback;
  isWhiteIcon?: boolean;
};

// TODO: Found some components which have duplicated logic. Unify the components. Eg: FareFamilyItem, BaggageItem, etc
function RuleItem({
  icon,
  testIdPrefix,
  isTextDimmed = false,
  message,
  onInfoClick,
  isWhiteIcon = false,
}: RuleItemProps): JSX.Element {
  const testId = buildTestId(testIdPrefix, 'RuleItem');

  return (
    <Styled.RuleItem $isWhiteIcon={isWhiteIcon} $hasInfoIcon={_isFunction(onInfoClick)}>
      {icon}
      <Typography
        color={isTextDimmed ? COLOR_VARIANTS.GREYCHATEAU : COLOR_VARIANTS.MINESHAFT}
        testId={testId}
        variant={TYPOGRAPHY_VARIANT.BODY2}
        component="p"
      >
        {message}
      </Typography>
      {_isFunction(onInfoClick) && (
        <Icons.InfoCircleIcon
          onClick={onInfoClick}
          cursor="pointer"
          width="20"
          height="20"
          color={color(COLOR_VARIANTS.AQUA100)}
        />
      )}
    </Styled.RuleItem>
  );
}

export default RuleItem;
